import { AlertDialog, Icon } from '@hs-baumappe/ui';
import { useTranslation } from 'react-i18next';

interface DraftSignatureNotAllowedDialogProps {
  open: boolean;
  onRequestClose: (reason: string) => void;
  onAssignDocumentClick: () => void;
  onCancelClick: () => void;
}

const testIdPrefix = `draft-signature-not-allowed`;

export default function DraftSignatureNotAllowedDialog({
  open,
  onRequestClose,
  onAssignDocumentClick,
  onCancelClick,
}: DraftSignatureNotAllowedDialogProps): JSX.Element {
  const { t } = useTranslation(undefined, { keyPrefix: 'document.draftSignatureNotAllowedDialog' });

  return (
    <AlertDialog
      open={open}
      title={t('title')}
      description={t('description')}
      confirmButtonProps={{
        startIcon: <Icon size={20} name="feed-list" aria-hidden="true" />,
        'data-testid': `${testIdPrefix}-select-project-button`,
      }}
      confirmButtonText={t('confirmButtonText')}
      cancelButtonText={t('cancelButtonText')}
      cancelButtonProps={{ 'data-testid': `${testIdPrefix}-cancel-button` }}
      onConfirm={onAssignDocumentClick}
      onCancel={onCancelClick}
      onRequestClose={onRequestClose}
      contentTestId={`${testIdPrefix}-dialog`}
    />
  );
}
